module.exports = __webpack_public_path__ + "img/SES_235420001.3aee5fc2.jpg";